import React, { useState } from 'react';
import { FiCheck } from 'react-icons/fi';
import { Button, PageContainer } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import './serviceSelection.css';
import { COMPANY_CONFIG, isACS } from '../../../constants/companyConfig';

const ServiceSelectionNode = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const useAlternate = COMPANY_CONFIG.features?.customNodeHandling;
  const packages = [
    {
      speed: '50 Mbps',
      price: '$49.95',
      devices: '5-7 Devices',
      users: '2-3 Users',
    },
    {
      speed: '100 Mbps',
      price: '$69.95',
      devices: '8-10 Devices',
      users: '3-4 Users',
    },
    {
      speed: '250 Mbps',
      price: '$89.95',
      devices: '10-12 Devices',
      users: '4-5 Users',
      bestValue: true,
    },
    {
      speed: '500 Mbps',
      price: '$109.95',
      devices: '12-15 Devices',
      users: '5+ Users',
    },
    {
      speed: '1 Gbps',
      price: '$129.95',
      devices: '15+ Devices',
      users: '5+ Users',
    },
  ];

  const handleSelect = (index) => {
    setSelectedPackage(index === selectedPackage ? null : index);
  };

  return (
    <PageContainer >
      <h2 className="serviceSelectionNode-Title">{useAlternate ? "Prepaid Internet Plans" : "Internet Plans"}</h2>
      <p className="serviceSelectionNode-Subtitle">
        {useAlternate?`Explore and choose your services. You can make changes at any time.`:`Find your perfect plan to fit your needs. Explore our options and pick
        the one that's right for you.`}
      </p>

      <div className={`serviceSelectionNode-Grid ${isACS ? 'acs' : ''}`}>
        {packages.map((pkg, index) => (
          <div
            key={index}
            className={`serviceSelectionNode-Card ${selectedPackage === index ? 'serviceSelectionNode-selected' : ''}`}
            onClick={() => handleSelect(index)}
          >
            <div className="serviceSelectionNode-TopSection">
              <img
                src="/images/icons/cloud-icon.png"
                alt="cloud"
                className="serviceSelectionNode-CloudImg"
              />
              {pkg.bestValue && (
                <div className="serviceSelectionNode-bestValue">Best value</div>
              )}
              <div className="serviceSelectionNode-Speed">{pkg.speed}</div>
              <div className="serviceSelectionNode-Price">
                <span className="serviceSelectionNode-PriceBold">
                  {pkg.price}
                </span>
                <span className="serviceSelectionNode-PriceUnit">/month</span>
              </div>
            </div>

            <div className="serviceSelectionNode-BottomSection">
              <ul className="serviceSelectionNode-Details">
                <li>
                  <FiCheck /> {pkg.devices}
                </li>
                <li>
                  <FiCheck /> {pkg.users}
                </li>
              </ul>
              <Button
                node={'serviceSelectionNode'}
                customId={ELEMENT_IDS.NEXT_STEP_BUTTON}
                label="Select Plan"
                right={<span className="serviceSelectionNode-Arrow">→</span>}
                fullWidth
              />
            </div>
          </div>
        ))}
      </div>

      <div className="serviceSelectionNode-buttonRow">
        <Button
          customId={ELEMENT_IDS.PREVIOUS_STEP_BUTTON}
          label="Back"
          variant="secondary"
        />
      </div>
    </PageContainer>
  );
};

export default ServiceSelectionNode;
